import React, { useState, useEffect } from "react";
import fs from 'fs';
import Typography from "@mui/material/Typography";
import {
  Box,
  Button,
  Grid,
  TextField,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from "@mui/material";
import moment from "moment";
import { Helmet } from "react-helmet";
import AwsAdminAccess from "./AwsAdminAccess";
import AwsLimitedAccess from "./AwsLimitedAccess";
import AzureAdminAccess from "./AzureAdminAccess";
import AzureLimitedAccess from "./AzureLimitedAccess";
import GcpAdminAccess from "./GcpAdminAccess";


export default function Configurations(props) {
  const { onState, nooftrainee, value, activeStep, handleBack, handleNext, classes } = props;

  // console.log("state.nooftrainee", nooftrainee);

  const [state, setState] = React.useState({
    admin: "",
    provider: "",
    customized_variable: "",
  });

  const handleReload = () => {
    window.location.reload();
  };

  const [selectedAwsValue, setSelectedAwsValue] = React.useState("a");
  const [selectedAzureValue, setSelectedAzureValue] = React.useState("a");
  const [selectedGcpValue, setSelectedGcpValue] = React.useState("a");
  const [selectedInstanceValue, setSelectedInstanceValue] = React.useState("ec2-medium");
  const [selectedInstanceValue2, setSelectedInstanceValue2] = React.useState("rds-medium");

  const [awsstate, setAwsState] = React.useState({});
  const [azurestate, setAzureState] = React.useState({});
  const [gcpstate, setGcpState] = React.useState({});
  const [textFieldValue, setTextFieldValue] = React.useState('');

  const [userEmail, setUserEmail] = useState([]);
  const [emailValidity, setEmailValidity] = useState([]);

  const [awsfind, setAwsfind] = useState(false);
  const [azurefind, setAzurefind] = useState(false);

  const [checkstate, setCheckstate] = React.useState({});
  const handlecheckChange = (event) => {
    setCheckstate({ ...checkstate, [event.target.name]: event.target.checked });
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const [confirmation, setconfirmation] = React.useState(false);

  const handleClickConfirmation = () => {
    setconfirmation(true);
  };

  const handleCloseConfirmation = () => {
    setconfirmation(false);
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    let NsDate = new Date();
    let nsminDate = moment(NsDate).format("YYYY-MM-DD");
    var email = localStorage.getItem("email");
    var customize;
    let isValid = true;

    if (state.provider === "Gcp") {
      userEmail.forEach((email, index) => {
        if (email.trim() === '') {
          isValid = false;
          const updatedValidity = [...emailValidity];
          updatedValidity[index] = {
            isValid: false,
            isEmpty: true
          };
          setEmailValidity(updatedValidity);
        } else {
          const updatedValidity = [...emailValidity];
          updatedValidity[index] = {
            isValid: true,
            isEmpty: false
          };
          setEmailValidity(updatedValidity);
        }
      });
      if (!isValid) {
        return;
      }
    }

    if (state.provider === "Aws") {
      const admin = "admin";
      if (selectedAwsValue === "a") {
        awsstate[admin] = true;
      } else {
        awsstate[admin] = false;
      }
      customize = awsstate;
      var name = "ec2";
      var name1 = "rds";
      if (customize[name] !== "undefined" && customize[name1] !== "undefined") {
        customize[selectedInstanceValue] = customize[name];
        customize[selectedInstanceValue2] = customize[name1];
      } else if (customize[name] !== "undefined" && customize[name1] === "undefined") {
        customize[selectedInstanceValue] = customize[name];
      } else if (customize[name] === "undefined" && customize[name1] !== "undefined") {
        customize[selectedInstanceValue2] = customize[name1];
      }
      else {
        customize = awsstate;
      }
    } else if (state.provider === "Azure") {
      const admin = "owner";
      if (selectedAzureValue === "a") {
        azurestate[admin] = true;
      } else {
        azurestate[admin] = false;
      }
      customize = azurestate;
    } else {
      const admin = "admin";
      if (selectedGcpValue === "a") {
        gcpstate[admin] = true;
      } else {
        gcpstate[admin] = false;
      }
      customize = gcpstate;
    }

    delete customize[""];
    var value = JSON.stringify(customize);
    // console.log(value);
    const id1 = "provider";
    const id2 = "customized_variable";

    onState((prevState) => ({
      ...prevState,
      [id1]: state.provider,
      [id2]: value,
      userEmail: userEmail,
    }));
    handleNext();
  };


  useEffect(() => {
    setUserEmail(Array(nooftrainee).fill(''));
    setEmailValidity(Array(nooftrainee).fill({ isValid: true, isEmpty: false }));
  }, [nooftrainee]);

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleEmailChange = (index, value) => {
    const updatedEmails = [...userEmail];
    updatedEmails[index] = value;
    setUserEmail(updatedEmails);

    const updatedValidity = [...emailValidity];
    updatedValidity[index] = {
      isValid: validateEmail(value),
      isEmpty: value === ''
    };
    setEmailValidity(updatedValidity);
  };

  // console.log("userEmail", userEmail);

  const allEmailsValid = () => {
    return emailValidity.every(email => email.isValid && !email.isEmpty);
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>LabAsService</title>
      </Helmet>
      <Box sx={{ pb: 2 }}>
        <Typography variant="h6" gutterBottom>
          Provider and Ownership
        </Typography>
        <Divider />
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            fullWidth
            name="provider"
            id="provider"
            helperText="Please select the provider for Cloudlab"
            onChange={handleChange}
            required
            select
            SelectProps={{ native: true }}
            autoComplete="shipping address-line1"
          >
            <option key="" value="">
              ---Choose the Cloud Provider---
            </option>
            <option key="aws" value="Aws">
              AWS
            </option>
            <option key="azure" value="Azure">
              Azure
            </option>
            <option key="gcp" value="Gcp">
              GCP
            </option>
            <option key="alibaba" disabled value="alibaba">
              Alibaba (Up Coming)
            </option>
            <option key="oracle" disabled value="oracle">
              Oracle (Up Coming)
            </option>
          </TextField>
        </Grid>
        <Grid item xs={12}>
          {state.provider === "Aws" ? (
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <AwsAdminAccess
                  selectedValue={selectedAwsValue}
                  setSelectedValue={setSelectedAwsValue}
                />
              </Grid>
              <Grid item xs={6}>
                <AwsLimitedAccess
                  selectedValue={selectedAwsValue}
                  setSelectedValue={setSelectedAwsValue}
                  awsstate={awsstate}
                  setAwsState={setAwsState}
                  setAwsfind={setAwsfind}
                  selectedValue1={selectedInstanceValue}
                  selectedValue2={selectedInstanceValue2}
                  setSelectedValue1={setSelectedInstanceValue}
                  setSelectedValue2={setSelectedInstanceValue2}
                />
              </Grid>
            </Grid>
          ) : state.provider === "Azure" ? (
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <AzureAdminAccess
                  selectedValue={selectedAzureValue}
                  setSelectedValue={setSelectedAzureValue}
                />
              </Grid>
              <Grid item xs={6}>
                <AzureLimitedAccess
                  selectedValue={selectedAzureValue}
                  setSelectedValue={setSelectedAzureValue}
                  azurestate={azurestate}
                  setAzureState={setAzureState}
                  setAzurefind={setAzurefind}
                />
              </Grid>
            </Grid>
          ) : state.provider === "Gcp" ? (
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <GcpAdminAccess
                  selectedValue={selectedGcpValue}
                  setSelectedValue={setSelectedGcpValue}
                />
              </Grid>
              <Grid item xs={12} style={{ marginBottom: "10px" }}>
                <Typography variant="h6">
                  Enter the Gmail ID (or) G-suite ID
                </Typography>
                <Divider />
              </Grid>
              <Grid container spacing={2} style={{ marginLeft: "10px" }}>
                {userEmail.map((email, index) => (
                  <Grid item xs={6} key={index}>
                    <TextField
                      label={`Trainee ${index + 1}`}
                      value={email}
                      onChange={(e) => handleEmailChange(index, e.target.value)}
                      fullWidth
                      style={{ marginBottom: "10px" }}
                      error={!emailValidity[index].isValid || emailValidity[index].isEmpty}
                      helperText={
                        emailValidity[index].isEmpty
                          ? "This field is required"
                          : !emailValidity[index].isValid
                            ? "Invalid email address"
                            : ""
                      }
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
      </Grid>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          pt: 2,
        }}
      >
        <div>
          <Tooltip title="Cancel and reset this step">
            <span>
              <Button
                variant="contained"
                color="primary"
                onClick={handleReload}
                className={classes}
                sx={{ borderRadius: '50px' }}
              >
                Cancel
              </Button>
            </span>
          </Tooltip>
        </div>
        <div className={classes}>
          {activeStep !== 0 && (
            <Tooltip title="Go back to previous step">
              <span>
                <Button onClick={handleBack} className={classes} sx={{ borderRadius: '50px', mr: 0.5 }}>
                  Back
                </Button>
              </span>
            </Tooltip>
          )}
          {checkstate.checkedB ? (
            <Tooltip title={(result <= 0 || (state.provider === "Gcp" && !allEmailsValid())) ? "Complete required fields to proceed" : "Proceed to next step"}>
              <span>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleClickConfirmation}
                  className={classes}
                  disabled={result <= 0 || (state.provider === "Gcp" && !allEmailsValid())}
                  sx={{ borderRadius: '50px' }}
                >
                  Next
                </Button>
              </span>
            </Tooltip>
          ) : (
            <Tooltip title={(!state.provider || (state.provider === "Gcp" && !allEmailsValid())) ? "Complete required fields to proceed" : "Proceed to next step"}>
              <span>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmitClick}
                  className={classes}
                  disabled={!state.provider || (state.provider === "Gcp" && !allEmailsValid())}
                  sx={{ borderRadius: '50px' }}
                >
                  Next
                </Button>
              </span>
            </Tooltip>
          )}
        </div>
      </Box>
      <div style={{ alignItems: "center", display: "flex", width: "600px" }}>
        <Dialog
          open={confirmation}
          onClose={handleCloseConfirmation}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            The below applied specifications will get reflected on your machine{" "}
            <strong style={{ color: "#EF5350" }}>
              {localStorage.getItem("specifyusername")}
            </strong>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description"></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Tooltip title="Cancel and close dialog">
              <span>
                <Button onClick={handleCloseConfirmation} color="primary" sx={{ borderRadius: '50px' }}>
                  Cancel
                </Button>
              </span>
            </Tooltip>
            <Tooltip title="Apply these configurations">
              <span>
                <Button onClick={handleSubmitClick} color="primary" autoFocus sx={{ borderRadius: '50px' }}>
                  Apply
                </Button>
              </span>
            </Tooltip>
          </DialogActions>
        </Dialog>
      </div>
    </React.Fragment>
  );
}
